module.exports = __webpack_public_path__ + "img/bespoke123_22.15cded97.jpg";